import {
  actorCanPickAnyCompanyGroup,
  actorUsesOwnCompanyGroupScope,
  isActorCompanyAdmin,
  resolveActorCompanyAdminId,
  resolveEffectiveCompanyGroupId,
} from './adminActorContext'

type UserLike = Record<string, unknown> | null | undefined

export type VesselCreateOwnership = {
  companyGroupAdminId: number | null
  companyAdminId: number | null
  requiresCompanyGroupSelection: boolean
  showSubCompanyPicker: boolean
  usesOwnCompanyGroupScope: boolean
  usesOwnCompanyAdminScope: boolean
}

export function resolveVesselCreateOwnership(currentUser: UserLike): VesselCreateOwnership {
  const requiresCompanyGroupSelection = actorCanPickAnyCompanyGroup(currentUser)
  const usesOwnCompanyGroupScope = actorUsesOwnCompanyGroupScope(currentUser)
  const usesOwnCompanyAdminScope = isActorCompanyAdmin(currentUser)

  if (requiresCompanyGroupSelection) {
    return {
      companyGroupAdminId: null,
      companyAdminId: null,
      requiresCompanyGroupSelection: true,
      showSubCompanyPicker: true,
      usesOwnCompanyGroupScope: false,
      usesOwnCompanyAdminScope: false,
    }
  }

  if (usesOwnCompanyGroupScope) {
    return {
      companyGroupAdminId: resolveEffectiveCompanyGroupId(currentUser),
      companyAdminId: null,
      requiresCompanyGroupSelection: false,
      showSubCompanyPicker: true,
      usesOwnCompanyGroupScope: true,
      usesOwnCompanyAdminScope: false,
    }
  }

  if (usesOwnCompanyAdminScope) {
    return {
      companyGroupAdminId: resolveEffectiveCompanyGroupId(currentUser),
      companyAdminId: resolveActorCompanyAdminId(currentUser),
      requiresCompanyGroupSelection: false,
      showSubCompanyPicker: false,
      usesOwnCompanyGroupScope: false,
      usesOwnCompanyAdminScope: true,
    }
  }

  return {
    companyGroupAdminId: resolveEffectiveCompanyGroupId(currentUser),
    companyAdminId: resolveActorCompanyAdminId(currentUser),
    requiresCompanyGroupSelection: false,
    showSubCompanyPicker: false,
    usesOwnCompanyGroupScope: false,
    usesOwnCompanyAdminScope: false,
  }
}

export function resolveVesselCreatePayloadIds(
  ownership: VesselCreateOwnership,
  selectedCompanyGroupAdminId: number,
  selectedSubCompanyId: number
): { companyGroupAdminId: number; companyAdminId?: number } {
  if (ownership.requiresCompanyGroupSelection) {
    return {
      companyGroupAdminId: selectedCompanyGroupAdminId,
      companyAdminId: selectedSubCompanyId > 0 ? selectedSubCompanyId : undefined,
    }
  }

  if (ownership.usesOwnCompanyGroupScope) {
    const companyGroupAdminId = Number(ownership.companyGroupAdminId ?? 0)
    return {
      companyGroupAdminId,
      companyAdminId: selectedSubCompanyId > 0 ? selectedSubCompanyId : undefined,
    }
  }

  if (ownership.usesOwnCompanyAdminScope) {
    return {
      companyGroupAdminId: Number(ownership.companyGroupAdminId ?? 0),
      companyAdminId: Number(ownership.companyAdminId ?? 0) || undefined,
    }
  }

  const companyGroupAdminId = Number(ownership.companyGroupAdminId ?? selectedCompanyGroupAdminId ?? 0)
  return {
    companyGroupAdminId,
    companyAdminId:
      Number(ownership.companyAdminId ?? selectedSubCompanyId ?? 0) > 0
        ? Number(ownership.companyAdminId ?? selectedSubCompanyId)
        : undefined,
  }
}
